<template>
    <div class="textarea-box" v-if="isInit">
        <el-form ref="form" :model="field" :label-width="field.name ? '120px' : '0'">
            <el-form-item
                class="input-row"
                :label="field.desc"
                prop="def_val"
                :rules="fieldRules">
                <div v-if="field.name" slot="label" class="label-item common">
                    <p class="label-text">{{ field.desc }}</p>
                    <el-tooltip class="item" effect="light" placement="bottom-start">
                        <div slot="content">
                            - name: <strong>{{ field.name }}</strong><br/>
                        </div>
                        <i class="label-icon el-icon-info"></i>
                    </el-tooltip>
                </div>
                <el-input
                    type="textarea"
                    class="field-input"
                    v-model="field.def_val"
                    :rows="3"
                    :placeholder="`请填写${field.desc || '此处'}的内容`"></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import moment from 'moment';

export default {
    name: 'textarea-box',
    props: ['field', 'autoInit'],
    data() {
        return {
            // resField: this.field,
            fieldRules: {
                required: this.field.require,
                message: `请填写'${this.field.desc}'的内容`,
                trigger: 'blur'
            },
            isInit: this.autoInit
            // fieldRules: {
            //     required: true,
            //     message: '12sddfasdf',
            //     trigger: 'blur'
            // }
        }
    },
    components: {
    },
    watch: {
    },
    methods: {
        initData() {
            this.isInit = true;
        },
        fieldBeReady() {
            // 确认组件是否就绪
            return this.$refs['form'];
        },
        getResField() {
            let isValidate = false;
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    isValidate = true;
                } else {
                    isValidate = false;
                }
            });
            if (!isValidate) {
                return;
            }
            return this.field;
        }
    },
    computed: {
    },
    mounted() {
    }
}
</script>
<style lang="less">
    @import (reference) '../../styles/public.less';
    .textarea-box {
        .label-item();
    }
</style>



// WEBPACK FOOTER //
// src/components/compEditForm/textareaBox.vue